import http from '@/utils/http';
export const getOssSignature = () => {
  return http.get(`hxb-backend/token/oos/signature`);
};
